__turbopack_context__.v({
  "ascii": "ascii-module-scss-module__H8fUDq__ascii",
  "canvas": "ascii-module-scss-module__H8fUDq__canvas",
  "dropzone": "ascii-module-scss-module__H8fUDq__dropzone",
  "instruction": "ascii-module-scss-module__H8fUDq__instruction",
  "open": "ascii-module-scss-module__H8fUDq__open",
});
